import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'
import PropagateLoader from "react-spinners/PropagateLoader";

export default class Loader extends Component {
    render() {
        return (
            <>
                <Container fluid>
                    <Row>
                        <Col xl='12'>
                        <div className='d-flex justify-content-center'>
                            <PropagateLoader
                                color="#063763"
                                size={25}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        </div>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}
